exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */\n/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */[dir] .rateDetailTable .content,[dir] .rateDetailTable .innerTable{margin-bottom:30px}.rateDetailTable .innerTable .innerTableRow{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}[dir] .rateDetailTable .innerTable .innerTableRow{background-color:#fff;padding:10px 30px;margin-bottom:1px}[dir=ltr] .rateDetailTable .innerTable .innerTableRow.indented{padding-left:50px}[dir=rtl] .rateDetailTable .innerTable .innerTableRow.indented{padding-right:50px}.rateDetailTable .innerTable .innerTableRow .leftInnerRow{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-negative:10000;flex-shrink:10000}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/rate-details/rate-details.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/rate-details/rate-details.component.scss
// module chunks = 0